
export enum PolyPizzaCategory {
  FoodAndDrink       = 0,
  Clutter            = 1,
  Weapons            = 2,
  Transport          = 3,
  FurnitureAndDecor  = 4,
  Objects            = 5,
  Nature             = 6,
  Animals            = 7,
  Buildings          = 8,
  PeopleAndCharacters = 9,
  ScenesAndLevels    = 10,
  Other              = 11,
}

export interface PolypizzaAsset {
  ID: string;
  Title: string;
  Description?: string;
  Attribution: string;
  Thumbnail: string;
  Download: string;
  Creator: {
    Username: string;
    DPURL: string;
  };
  Category: string;
  Tags: string[];
  Licence: string;
  Animated: boolean;
}
